import axios from 'axios'

const USERNAMES_FETCHED = 'USERNAMES_FETCHED'

const API_URL = process.env.API_URL

const state = {
  usernames: []
}

const actions = {
  fetchUsernames ({commit}) {
    return axios.get(API_URL + '/blacklist', {
      params: {
        type: 'username'
      }
    }).then(({data: {data}}) => {
      commit(USERNAMES_FETCHED, data)
      return data
    })
  },
  updateUsernames ({commit}, list) {
    return axios.post(API_URL + '/blacklist', {
      type: 'username',
      names: list
    }).then(() => {
      commit(USERNAMES_FETCHED, list)
      return list
    })
  }
}

const mutations = {
  [USERNAMES_FETCHED] (state, list) {
    state.usernames = list
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/blacklists.js